/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridgeline Plot Maker`)
};

const es_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Cordillera`)
};

const de_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridgeline-Plot-Generator`)
};

const nl_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ridgeline Plot Maker`)
};

const fr_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique en crêtes`)
};

const it_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di Grafici Ridgeline`)
};

const pt_br2_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráfico Ridgeline`)
};

const pt_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos Ridgeline`)
};

const ja_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リッジラインプロット作成ツール`)
};

const zh_ridge_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`山脊图生成器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_h1", locale)
	if (locale === "en") return en_ridge_h1(inputs)
	if (locale === "es") return es_ridge_h1(inputs)
	if (locale === "de") return de_ridge_h1(inputs)
	if (locale === "nl") return nl_ridge_h1(inputs)
	if (locale === "fr") return fr_ridge_h1(inputs)
	if (locale === "it") return it_ridge_h1(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_h1(inputs)
	if (locale === "pt") return pt_ridge_h1(inputs)
	if (locale === "ja") return ja_ridge_h1(inputs)
	return zh_ridge_h1(inputs)
};